import {
  Bank,
  ClockClockwise,
  CreditCard,
  HandCoins,
  Wallet,
  CalendarDots,
  MoneyWavy,
  QrCode
} from '@phosphor-icons/react'
import { Icon } from '@shopflo/ui'
import React from 'react'
import { IconProps } from 'src/lib/types/paymentPage'

const paymentMethodComponents = {
  CARD: CreditCard,
  WALLET: Wallet,
  UPI: Wallet,
  COD: HandCoins,
  SPLIT_COD: HandCoins,
  NETBANKING: Bank,
  BHARATX: Bank,
  PAY_LATER: ClockClockwise,
  EMI: CalendarDots
}

const imageOnlyPaymentMethods = ['SNPM', 'VELOCITY', 'SIMPL', 'SIMPL_PL']

export const paymentMethodImages: Record<string, string> = {
  SNPM: 'https://cashfreelogo.cashfree.com/assets_images/pg/cardless/64/snapmint.png',
  VELOCITY: 'https://d2s4qtdvyggozf.cloudfront.net/velocity.png'
}

interface PaymentMethodIconProps extends IconProps {
  paymentMethod: string
  iconColor?: string
}

const PaymentMethodIcon: React.FC<PaymentMethodIconProps> = ({
  paymentMethod,
  iconColor,
  size = 32,
  color = '#4D4D4D'
}) => {
  if (imageOnlyPaymentMethods.includes(paymentMethod)) {
    const imagePath = paymentMethodImages[paymentMethod as keyof typeof paymentMethodImages]
    return (
      <div className='rounded-md min-w-8'>
        <img src={imagePath} alt={paymentMethod} width={size} height={size} style={{ width: size, height: size }} />
      </div>
    )
  }

  const Component = paymentMethodComponents[paymentMethod as keyof typeof paymentMethodComponents]

  return (
    <Icon
      IconComponent={Component || MoneyWavy}
      size='lg'
      color={iconColor || color}
      iconProps={{ weight: 'duotone', style: { color: iconColor || color } }}
    />
  )
}

export default PaymentMethodIcon
